import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import Button from '../buttons/Rounded';
import MainLayout from '../layouts/Main';
import FormFrame from '../partials/FormFrame';

import styles from '../../../styles/pages/form.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const EmailConfirmedPage = ({ className }) => {
    const location = useLocation();
    const route = useUrlGenerator();
    useScrollToTop(location);

    return (
        <MainLayout>
            <div
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div
                    className={styles.inner}
                    style={{
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}
                >
                    <FormFrame
                        className={styles.formFrame}
                        title={
                            <FormattedMessage
                                defaultMessage="Email confirmed"
                                description="Form heading"
                            />
                        }
                    >
                        <p className={styles.formSuccess}>
                            <FormattedMessage
                                defaultMessage="Thank you! You can now rent movies from our website."
                                description="Form message"
                            />
                        </p>
                        <Button className={styles.button} href={route('home')}>
                            <FormattedMessage defaultMessage="Go home" description="Form button" />
                        </Button>
                    </FormFrame>
                </div>
            </div>
        </MainLayout>
    );
};
EmailConfirmedPage.propTypes = propTypes;
EmailConfirmedPage.defaultProps = defaultProps;

export default EmailConfirmedPage;
